// Port of api/fuel/app/classes/controller/api/monty/users/listing.php
import F from 'offline/filter/constants'
import { runListingEndpoint } from 'offline/api/listing'

export default function(params) {
	return runListingEndpoint(params, F.OWNER_USER)
}
